import React, { useEffect, useState } from 'react';
import { Package, Table, ChefHat, Settings } from 'lucide-react';
import { Card, CardContent } from '../../components/ui';
import { getDashboardSummary } from '../../services/DashboardService';
import type { DashboardSummary } from '../../types/@types/dashboard';

const initialSummary: DashboardSummary = {
  totalProducts: 0,
  totalTables: 0,
  availableFlavors: 0,
  categories: 0,
};

import { ActivityLogs } from './ActivityLogs';

const Dashboard2: React.FC = () => {
  const [summary, setSummary] = useState<DashboardSummary>(initialSummary);

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getDashboardSummary();
        setSummary(data);
      } catch (err) {
        console.error('Error fetching dashboard summary', err);
      }
    }
    fetchData();
  }, []);

  const cards = [
    {
      title: 'Total Productos',
      value: summary.totalProducts,
      icon: <Package size={32} className="text-blue-500" />,
    },
    {
      title: 'Total Mesas',
      value: summary.totalTables,
      icon: <Table size={32} className="text-green-500" />,
    },
    {
      title: 'Sabores Disponibles',
      value: summary.availableFlavors,
      icon: <ChefHat size={32} className="text-purple-500" />,
    },
    {
      title: 'Categorías',
      value: summary.categories,
      icon: <Settings size={32} className="text-orange-500" />,
    },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-text">Dashboard</h1>
      <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((card) => (
          <Card key={card.title} className="overflow-hidden">
            <CardContent className="flex items-center gap-4 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary" aria-hidden>
                {card.icon}
              </span>
              <div className="min-w-0">
                <p className="text-xs font-semibold uppercase tracking-wide text-text-muted">{card.title}</p>
                <p className="mt-1 text-3xl font-semibold text-text">{card.value}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </dl>

      <div className="pt-6">
        <ActivityLogs />
      </div>
    </div>
  );
};

export default Dashboard2;
